module.exports = __webpack_public_path__ + "static/media/decor1.d40314bd.jpg";